import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import './Login.css';

// Firebase
import { firebaseSdk } from '../Firebase/Init';

function Login() {
    const [form, setForm] = useState({
        username: '',
        password: ''
    });
    const history = useHistory();

    // Handle form changes
    const handleChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;

        setForm({ ...form, [inputName]: inputValue });
    }

    // Create new user
    const handleSubmit = (event) => {
        // Stop page from refreshing
        event.preventDefault();

        firebaseSdk.auth().signInWithEmailAndPassword(form.username, form.password)
            .then((user) => {
                // User is signed in.
                localStorage.setItem('user', JSON.stringify(user));
                history.push('/Home');
            })
            .catch((error) => {
                // User is signed out.
                alert(error);
            });
    }

    return (
        <div className="Login-page">
            <form>
                <div className="Login-body">
                    <div className="Login-header">Online Ordering Login</div>
                    <input className="Login-input" name="username" type="text" onChange={handleChange} />
                    <input className="Login-input" name="password" type="password" onChange={handleChange} />
                    <input className="Login-input Login-submit" type="submit" value="Login" onClick={handleSubmit} />
                    <Link to='/Register' className="Register-button">Register</Link>
                </div>
            </form>
        </div>
    )
}

export default Login;